//#region src/core/ui/playback-rate-button/data.ts
/** @internal */
const PlaybackRateButtonDataAttrs = { 
/** Current playback rate. */
rate: "data-rate" };
//#endregion
export { PlaybackRateButtonDataAttrs };
